import React from "react";
import Forms from "./form";
export default function LogIn() {
  return (
    <>
      <Forms />
    </>
  );
}
